import { Component, inject } from '@angular/core';
import { ALL_VIEW_ID, FOLLOWING_VIEW_ID } from '../../../../core/src/lib/inbox.constants';
import { ViewService } from '../../../../core/src/lib/view.service';
import { CommonModule } from '@angular/common';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';

@Component({
  selector: 'inbox-views-empty',
  templateUrl: './inbox-views-empty.component.html',
  styleUrls: ['./inbox-views-empty.component.scss'],
  standalone: true,
  imports: [CommonModule, GalaxyEmptyStateModule],
})
export class InboxViewsEmptyComponent {
  private readonly viewService = inject(ViewService);
  readonly selectedViewId$ = this.viewService.selectedViewId$;
  allViewId = ALL_VIEW_ID;
  followingViewId = FOLLOWING_VIEW_ID;
}
